import * as axiosService from "../axiosService";

export const getOnTripTruckTrackingList = () => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/OnTripTruckTrackingList?pageNumber=1&pageSize=20`);
};

export const getAvailableTruckTrackingList = () => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/FleetManagement/AvailableTruckTrackingList?pageNumber=1&pageSize=20`);
};